import { render } from "./CleanTemplate.vue?vue&type=template&id=d3ee587e&ts=true"
import script from "./CleanTemplate.vue?vue&type=script&lang=ts"
export * from "./CleanTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__